import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, debounce, Options} from "../utils/decorators";

const ACTIVE_CLASS = 'hero-gallery-vertical__item--active';
const HIDDEN_CLASS = 'hero-gallery-vertical__item--hidden';

const VISIBLE_CONTENT_AREA_PX = 175;

const IE11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;

@Options({
    template: false,
    ui: {
        list: '[data-js-ui=vertical-slider__list]',
        slides: '[data-js-ui=vertical-slider__slide]',
        dotsContainer: '[data-js-ui=vertical-slider__dots-container]',
        dots: '[data-js-ui=vertical-slider__dots]',
        loader: '[data-js-ui=vertical-slider__loader]'
    },
})
export default class VerticalSlider extends Marionette.View<Backbone.Model>{
    slides = null;
    currentSlide = null;
    totalSlides = null;
    slideHeight = null;
    pluginContainer = null;

    constructor(options?:object) {
        super(options);

        this.slides = this.ui.slides;
        this.currentSlide = 0;
        this.totalSlides = this.slides.length;

        this.slideHeight = this.slides[0].scrollHeight;
        //this.ui.list.height(this.slideHeight * this.totalSlides);

        this.attachScrollEvent();
        this.attachResizeEvent();

        this.updateActiveSlide();

        this.pluginContainer = document.querySelector('.plugin-container');
        if (this.slides.length > 1) {
            this.pluginContainer.classList.add('plugin-container--sticky');
        }

        let slideHeight = this.slideHeight;
        this.slides.each((index, elem) => {
            elem.style.zIndex = 1 + (this.totalSlides - index);

            let content: any = elem.querySelector('.hero-gallery-vertical__content-wrapper');
            //content.style.opacity = 0;

            let dot = $(`<div class="dot" data-n="${index}"></dot>`)
            dot.on('click', function() {
                window.scrollTo({
                    top: index * slideHeight + 1,
                    behavior: 'smooth',
                });
            });

            this.ui.dots.append(dot);
        });
    }

    attachScrollEvent() {
        window.addEventListener('scroll', event => {
            const top = window.scrollY || window.pageYOffset || document.body.scrollTop;;

            if (top > this.totalSlides * this.slideHeight) {
                this.currentSlide = null;
            } else {
                for (let i = 0; i < this.totalSlides; i++) {
                    if (top > i * this.slideHeight) {
                        this.currentSlide = i;
                    }
                }
            }

            if (top > (this.totalSlides - 1) * this.slideHeight) {
                // Do nothing
            } else if (IE11) {
                this.pluginContainer['style'].marginTop = -((this.slideHeight * (this.totalSlides - 1)) - top + VISIBLE_CONTENT_AREA_PX) + 'px';
            }

            this.updateActiveSlide();
        });
    }

    attachResizeEvent() {
        window.addEventListener('resize', event => {
            this.updateContentPosition();
            this.updateActiveSlide()
        });
    }

    updateActiveSlide() {
        this.ui.dots.find('.dot').removeClass('active');

        // if the slider is onscreen...
        if(this.currentSlide != null) {

            // give the slides classes based on their position
            // relative to the current slide

            // for slides 0..n..total
            //     n < current -> [hidden, active]
            //     n = current -> [active]
            //     n > current -> []
            this.slides.each((index, elem) => {
                elem.classList.remove(HIDDEN_CLASS);
                elem.classList.remove(ACTIVE_CLASS);
                if (index < this.currentSlide) {
                    elem.classList.add(ACTIVE_CLASS);
                    elem.classList.add(HIDDEN_CLASS);
                }
            });
            this.slides[this.currentSlide].classList.add(ACTIVE_CLASS);
            this.ui.dots.find(`.dot[data-n=${this.currentSlide}]`).addClass('active');
        } else {
            // slides are all off screen, give hidden & active
            this.slides.each((index, elem) => {
                elem.classList.add(HIDDEN_CLASS);
                elem.classList.add(ACTIVE_CLASS);
            });
        }

        if(this.currentSlide == this.totalSlides - 1 || this.currentSlide == null) {
            this.ui.dotsContainer.removeClass('attached');
        } else {
            this.ui.dotsContainer.addClass('attached');
        }

    }

    updateContentPosition() {
        let pageWidth = Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );

        this.slideHeight = this.slides[0].scrollHeight;
        this.ui.list.height(this.slideHeight * this.totalSlides);

        let contentHeight = this.pluginContainer.scrollHeight;
        this.pluginContainer.removeAttribute('style');

        document.querySelector('footer').style.marginTop = '0px';
        if (pageWidth > 768) {
            // this.pluginContainer['style'].marginBottom = (contentHeight + VISIBLE_CONTENT_AREA_PX) + 'px';
            // this.pluginContainer['style'].marginBottom = contentHeight + 'px';
            document.querySelector('footer').style.marginTop = contentHeight + 'px';

            if (IE11) {
                document.querySelector('footer').style.marginTop = '0px';
                this.pluginContainer['style'].marginTop = -((this.slideHeight * (this.totalSlides - 1)) + VISIBLE_CONTENT_AREA_PX) + 'px';
            }
        }

        this.pluginContainer.classList.add('plugin-container--sticky-inited');
    }

    start() {
        this.updateContentPosition();
        this.ui.loader.addClass('loaded');
        this.ui.list.addClass('loaded');

        this.slides.each((index, elem) => {
            let content: any = elem.querySelector('.hero-gallery-vertical__content-wrapper');
            content.style.opacity = 1;
        });

        if (IE11) {
            let evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }

    }

    startGoodBrowsers() {
        if (document.readyState === 'complete') {
            this.start();
        } else {
            window.addEventListener('load', () => {
                this.start();
            });
        }
    }

    startPoorBrowsers() {
        console.log('older browser detected.');
        let loaded = false;

        if (document.readyState === 'interactive') {
            setTimeout(() => this.start(), 2000);
        } else {
            document.onreadystatechange = () => {
                if (loaded === false && document.readyState === 'interactive') {
                    setTimeout(() => this.start(), 2000);
                    loaded = true;
                }
            }
        }
    }

    onRender() {
        if (IE11) {
            this.startPoorBrowsers();

        } else {
            this.startGoodBrowsers();
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/vertical-slider.ts